import React from 'react';
import { Card } from './ui/Card';
import { Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Wir haben 100.000 € extra jeden Monat allein durch das Follow-Up generiert.',
  author: 'Luis Warkuss',
  role: 'Geschäftsführer',
  initial: 'L',
  color: 'bg-blue-500'
}, {
  quote: 'Wir sind von 250.000 € auf über 450.000 € Monatsumsatz gewachsen.',
  author: 'Henri CL',
  role: 'CEO',
  initial: 'H',
  color: 'bg-purple-500'
}, {
  quote: 'Wir haben unsere Umsätze verdreifacht bis verfünffacht – ohne unser Vertriebsteam massiv ausbauen zu müssen.',
  author: 'Steuer Mentoring',
  role: 'Partner',
  initial: 'S',
  color: 'bg-green-500'
}];
export function ResultsSection() {
  return <section className="py-20 bg-[#0A0E27]" data-id="element-211" data-mp="lriqw65p8nye">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-212" data-mp="3kg7vxv9kcwpd">
        <div className="text-center mb-16" data-id="element-213" data-mp="3pej6673rt984">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-214" data-mp="3pdhk77l7v2bm">
            Was meine Kunden erreichen
          </h2>
          <p className="text-[#94A3B8] max-w-2xl mx-auto" data-id="element-215" data-mp="y6bw67xhgxg0">
            Ergebnisse sprechen lauter als Worte. Hier sind echte Zahlen von
            Unternehmen, die CRM Kraft nutzen.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-216" data-mp="of7n1ouho6t3">
          {testimonials.map((item, index) => <Card key={index} variant="hover" className="p-8 flex flex-col h-full" data-id="element-217" data-mp="fgm43sl3uprs" data-mpi={index}>
              <Quote className="w-8 h-8 text-[#FF5722] mb-6 opacity-50" data-id="element-218" data-mp="aghl9vwq5iye" />
              <p className="text-lg text-white font-medium mb-8 flex-grow" data-id="element-219" data-mp="5i6ghzladyn1">
                "{item.quote}"
              </p>
              <div className="flex items-center gap-4 pt-6 border-t border-[#1E293B]" data-id="element-220" data-mp="kel2vlfnue3">
                <div className={`w-10 h-10 rounded-full ${item.color} flex items-center justify-center text-white font-bold`} data-id="element-221" data-mp="1zwphfxq6ju2y">
                  {item.initial}
                </div>
                <div data-id="element-222" data-mp="3pct3oaholy0p">
                  <div className="text-white font-bold" data-id="element-223" data-mp="3pc9x1pxhew1z">{item.author}</div>
                  <div className="text-xs text-[#94A3B8]" data-id="element-224" data-mp="3u531sdsya4e2">{item.role}</div>
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}